import { apolloClient } from "@/plugins/vue-apollo.js";

const deleteLandlord = (_variables) => {
  let responseFromApi;
  let variables = {
    id: _variables,
  };
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/landlord/api/mutations/delete_landlord.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/landlord/api/queries/landlord_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: '',
              sortBy: ''
            }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { deleteLandlord };
